// extracted by mini-css-extract-plugin
export default {"Container":"tincan_Container__m0nod"};